<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Slider">
          <!-- <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Eklenecek içerik adı ve arama motoru
                bağlantı linki benzersiz olmalıdır...</span
              >
            </div>
          </b-alert> -->
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            :to="`/sliders/home/create`"
          >
            Yeni Slider Ekle
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Slider">
          <swiper
            class="swiper-autoplay"
            :options="swiperOptions"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          >
            <swiper-slide v-for="slider in sliders" :key="slider.id">
              <b-img
                :src="`${slider.images.hero}`"
                fluid
              />
            </swiper-slide>
            <div slot="pagination" class="swiper-pagination" />
            <div slot="button-next" class="swiper-button-next" />
            <div slot="button-prev" class="swiper-button-prev" />
          </swiper>
        </b-card>
      </b-col>
    </b-row>
    <b-col cols="12">
      <b-card class="mb-3" title="Slider Listesi">
        <b-form>
          <b-row>
            <b-col cols="12">
              <table class="table b-table">
                <thead>
                  <th>#</th>
                  <th>GÖRSEL</th>
                  <th>SLIDER TİPİ</th>
                  <th>TARİH</th>
                  <th>İŞLEMLER</th>
                </thead>
                <draggable
                  v-model="sliders"
                  class="cursor-move"
                  tag="tbody"
                  @change="outputData"
                >
                  <tr v-for="slider in sliders" :key="slider.id">
                    <td>{{ slider.id }}</td>
                    <td>
                      <b-img
                        style="width:200px"
                        :src="`${slider.images.hero}`"
                        fluid
                      />
                    </td>
                    <td>{{ slider.sliderLinkType.name }}</td>
                    <td>{{ slider.createdAt }}</td>
                    <td>
                      <b-button-group class="float-left mr-2">
                        <b-button
                          v-for="language in languages"
                          :key="language.locale"
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          :variant="
                            slider.languages.find(
                              (element) => element == language.locale
                            )
                              ? 'outline-warning'
                              : 'outline-secondary'
                          "
                          :title="
                            slider.languages.find(
                              (element) => element == language.locale
                            )
                              ? 'Düzenle'
                              : 'Ekle'
                          "
                          @click="action(slider, language.locale)"
                        >
                          {{ language.locale.toUpperCase() }}
                        </b-button>
                      </b-button-group>
                      <b-button-group class="float-left">
                        <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-danger"
                          class="btn-icon rounded-circle"
                          @click="deleteConfirmText(slider.id)"
                        >
                          <feather-icon icon="TrashIcon" />
                        </b-button>
                      </b-button-group>
                    </td>
                  </tr>
                </draggable>
                <thead>
                  <th>#</th>
                  <th>GÖRSEL</th>
                  <th>SLIDER TİPİ</th>
                  <th>TARİH</th>
                  <th>İŞLEMLER</th>
                </thead>
              </table>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-col>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();
import "swiper/css/swiper.css";
export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    draggable,
    Swiper,
    SwiperSlide,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      swiperOptions: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      request: [],
      sliders: [],
      languages: [],
    };
  },
  watch: {},
  methods: {
    action(node, locale) {
      let translationControl = node.languages.find(
        (element) => element == locale
      );
      if (translationControl == undefined) {
        this.$router.push({
          path: `/sliders/home/create/translation/${node.id}?targetLocale=${locale}`,
        });
      } else {
        this.$router.push({
          path: `/sliders/home/edit/${node.id}?targetLocale=${locale}`,
        });
      }
    },
    outputData() {
      this.updateSubmit()
    },
    updateSubmit() {
      this.request = []
      Object.entries(this.sliders).forEach(([key, value]) => {
        let sliderOrder = {
          id: value.id,
          order: parseInt(key),
        };
        this.request.push(sliderOrder);
      });
      endpoints
        .putSlidersOrder({ sliders: this.request }, this.$i18n.locale, () => {})
        .then((data) => {
          this.$swal({
            icon: "success",
            title: "Güncelleme başarılı!",
            text: "Slider sıralaması güncellendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.languages = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSliders() {
      endpoints
        .getSliders(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.sliders = [];
          this.sliders = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteConfirmText(id) {
      this.$swal({
        title: "Sil?",
        text: "Eğitmeni silmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteSubmit(id);
        }
      });
    },
    deleteSubmit(id) {
      endpoints
        .deleteSliders(id, this.$i18n.locale, () => {})
        .then((data) => {
          this.getSliders();
          this.$swal({
            icon: "success",
            title: "Silme başarılı!",
            text: "Slider silindi",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getLanguages();
    this.getSliders();
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/swiper.scss";
</style>
